import Helper from "../../utility/helper";
import APIHelper from '../../utility/ApiHelper';
import APIURLConstants from "../../config/config";

const GenerateCompPostObject = (state, participant, agentInfo, compCount, isAdminUser) => {
    const eventInfo = Helper.getStorage('eventInfo');
    const userInfo = Helper.getStorage('userInfo');
    let requestObj = {
        ticketAllStarComplimentaryID: state.compID && state.compID.value ? state.compID.value : 0,
        eventID: eventInfo.eventID,
        userID: participant ? participant.userID : agentInfo ? agentInfo.userID : userInfo.userID,
        contactName: state.name.value,
        contactEmail: state.email.value,
        contactNo: state.phone.value,
        friNightID: 1,
        friCount: compCount?.TicketSetting ? parseInt(JSON.parse(compCount?.TicketSetting)?.ticketFriCompCount) : 0,
        satNightID: 2,
        satCount: compCount?.TicketSetting ? parseInt(JSON.parse(compCount?.TicketSetting)?.ticketSatCompCount) : 0,
        sunNightID: 3,
        sunCount: compCount?.TicketSetting ? parseInt(JSON.parse(compCount?.TicketSetting)?.ticketSunCompCount) : 0,
        createdBy: userInfo.userID,
        status: isAdminUser && state.status.value === 0 ? 1 : state.status.value
    }
    return requestObj;
}

// async function SaveComplimentaryData(postCompData) {
//     try {
//         let d = await APIHelper.post(
//             APIURLConstants.POST_ALLSTAR_EVENT_COMP_TICKETS, postCompData
//         );
//         return d;
//     } catch (e) {
//         console.log('error', e)
//         throw e;
//     }
// }

const CheckValidCompName = (name) => {
    let error = ''
    if (name === '') {
        error = 'Please Enter Name'
    }
    else if (!Helper.validNameacceptsinglequotesanddot(name)) {
        error = 'Please enter valid Name'
    }
    return error;
}

const CheckValidCompEmail = (email) => {
    let error = ''
    if (email === '') {
        error = 'Please Enter Email'
    } else if (!Helper.validEmail(email)) {
        error = 'Please enter valid Email'
    }
    return error;
}
const CheckValidCompPhone = (phone) => {
    let error = ''
    if (phone === '' || phone === '1') {
        error = 'Please Enter Phone';
    }

    // else if (!e.match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/))
    // {
    //     setCompPhoneError('Please Enter valid Phone');
    //     setHideSubmitButton(true)
    //     return { flag: 'false' };
    // }
    return error;
}


export const ticketHelper = {
    GenerateCompPostObject,
    // SaveComplimentaryData,
    CheckValidCompName,
    CheckValidCompEmail,
    CheckValidCompPhone
}